import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote1 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>AI AS A PLATFORM: THE INEVITABLE MARCH FROM LLMs TO TLMs
</b> <br/>
            <br />Massoud Alibakhsh <br/>
            CEO & Founder, OMADEUS, USA<br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            The AI industry is drifting toward a comfortable illusion: that ever-larger LLMs, wrapped in layers of “agents,” will somehow evolve into reliable, autonomous software. It’s a seductive story—and a convenient one for valuations—but it remains a bridge to nowhere. Agents simply amplify the core weakness of probabilistic models: unpredictability disguised as intelligence. Meanwhile, corporations are discovering that these systems can’t execute workflows, can’t guarantee outcomes, and can’t replace the missing architecture beneath them. This talk cuts through the hype. I’ll break down why the agentic path is structurally limited, why it cannot become the backbone of enterprise automation, and where the real future of intelligent software must emerge instead. The next era won’t come from stitching hallucinating models together—it will come from building a native architecture for reliability, communication, and intelligent coordination. We’ve been working on exactly that direction, and this session will open the door to what comes after today’s AI mythology.
            </div>

            <h6 className="par_header">Speaker’s Biography:</h6>
            <div className="par">
            Massoud is a tech entrepreneur with a background in Electrical Engineering and Computer Science. He's currently focused on implementing AI as a platform and the next revolution in human and machine communication at Xeba Technologies. His career achievements include founding prior technology companies Medicat and Nuesoft which grew from a few people to leading their industry segments and were later acquired. Massoud also holds a number of technology and software patents. His latest work is on a new architecture for deep integration of AI with traditional software applications to make software truly intelligent.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/alibakhsh.jpeg" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote1;